import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/sign/Login'
import DashBoard from "../views/dashboard/DashBoard";

import Layout from '../layout'
import {getToken} from "@/utils/auth";
// import {MenuRouter} from "./modules/menu";

import Role from "../views/role/Role"
import User from "../views/user/User"
import UserForm from "../views/user/UserForm"
import SecUsers from "../views/user/SecUsers"
import SecUser from "../views/user/SecUser"

import Menu from "../views/menu/Menu"
import Group from "../views/group/Group"
import Board from "../views/board/Board"
import BoardForm from "../views/board/BoardForm"

import Article from "../views/article/Article"
import ArticleForm from "../views/article/ArticleForm"
import ArticleView from "../views/article/ArticleView"

import Meeting from "../views/meeting/Meeting"
import MeetingSchedule from "@/views/meeting/MeetingSchedule"
import MeetingForm from "../views/meeting/MeetingForm"
import MeetingUser from "@/views/meeting/MeetingUser"

import Page from "../views/page/Page"
import PageForm from "../views/page/PageForm"

import Banner from "../views/banner/Banner"
import BannerForm from "../views/banner/BannerForm"

import Popup from "@/views/popup/Popup"
import PopupForm from "@/views/popup/PopupForm"

import Sms from "@/views/sms/Sms"
import Mail from "@/views/mail/Mail"

import Calendar from "@/views/schedule/Calendar"
import Site from "@/views/settings/Site"

import Statistics from "@/views/statistics/Statistics";

import Hypermeeting from "@/views/hypermeeting/Hypermeeting";

import Version from "@/views/version/Version";

import Products from "@/views/product/Products"
import ProductForm from "@/views/product/ProductForm"
import ProductDetail from "@/views/product/ProductDetail"

import Presents from "@/views/present/Presents"
import PresentForm from "@/views/present/PresentForm"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        children: [
            {
                path: 'dashboard',
                component: DashBoard,
                name: 'Dashboard'
            },
        ]
    },
    {
        path: '/role',
        component: Layout,
        children: [
            {
                path: '',
                component: Role,
                name: 'Role'
            }
        ]
    },
    {
        path: '/user/:state?',
        component: Layout,
        children: [
            {
                path: 'form/:userId?',
                component: UserForm,
                props: true
            },
            {
                path: '',
                component: User,
                name: 'User'
            }
        ]
    },
    {
        path: '/sec/users',
        component: Layout,
        children: [
            {
                path: '',
                component: SecUsers,
                name: 'SecUsers'
            },
            {
                path: 'form/:userId?',
                component: SecUser,
                props: true
            }
        ]
    },
    {
        path: '/menu',
        component: Layout,
        children: [
            {
                path: '',
                component: Menu,
                name: 'Menu'
            }
        ]
    },
    {
        path: '/group',
        component: Layout,
        children: [
            {
                path: '',
                component: Group,
                name: 'group'
            },
            {
                path: 'meeting',
                component: Meeting,
                name: 'meeting'
            },
            {
                path: 'meeting/schedule',
                component: MeetingSchedule,
            },
            {
                path: 'meeting/form/:meetingId?',
                component: MeetingForm,
            },
            {
                path: 'meeting/:meetingId/users',
                component: MeetingUser,
                props: true
            }
        ]
    },
    {
        path: '/board',
        component: Layout,
        children: [
            {
                path: '',
                component: Board,
                name: 'board'
            },
            {
                path: 'form/:id?',
                component: BoardForm,
                props: true
            },
        ]
    },
    {
        path: '/board/:id',
        component: Layout,
        children: [
            {
                path: 'articles',
                component: Article,
                name: 'article'
            },
            {
                path: 'article/form/:articleId?',
                component: ArticleForm
            },
            {
                path: 'article/view/:articleId?',
                component: ArticleView
            }
        ]
    },
    {
        path: '/schedule',
        component: Layout,
        children: [
            {
                path: '',
                component: Calendar
                ,
                name: 'schedule'
            }
        ]
    },
    {
        path: '/page',
        component: Layout,
        children: [
            {
                path: '',
                component: Page,
                name: 'page'
            },
            {
                path: 'form/:pageId?',
                component: PageForm,
            },
        ]
    },
    {
        path: '/banner/:bannerCategory',
        component: Layout,
        children: [
            {
                path: '',
                component: Banner,
                name: 'banner'
            },
            {
                path: 'form/:bannerId?',
                component: BannerForm,
            },
        ]
    },
    {
        path: '/popup',
        component: Layout,
        children: [
            {
                path: '',
                component: Popup,
                name: 'popup'
            },
            {
                path: 'form/:popupId?',
                component: PopupForm,
            },
        ]
    },
    {
        path: '/sms',
        component: Layout,
        children: [
            {
                path: '',
                component: Sms,
                name: 'sms'
            }
        ]
    },
    {
        path: '/mail',
        component: Layout,
        children: [
            {
                path: '',
                component: Mail,
                name: 'mail'
            }
        ]
    },
    {
        path: '/statistics',
        component: Layout,
        children: [
            {
                path: '',
                component: Statistics,
                name: 'Statistics'
            }
        ]
    },
    {
        path: '/site',
        component: Layout,
        children: [
            {
                path: '',
                component: Site,
                name: 'site'
            }
        ]
    },
    {
        path: '/hypermeeting',
        component: Layout,
        children: [
            {
                path: '',
                component: Hypermeeting,
                name: 'hypermeeting'
            }
        ]
    },
    {
        path: '/version',
        component: Layout,
        children: [
            {
                path: '',
                component: Version,
                name: 'version'
            }
        ]
    },
    {
        path: '/product',
        component: Layout,
        children: [
            {
                path: '',
                component: Products,
                name: 'products'
            },
            {
                path: 'form/:id?',
                component: ProductForm,
                props: true
            },
            {
                path: 'detail/:id?',
                component: ProductDetail,
                props: true
            }
        ]
    },
    {
      path: '/present',
      component: Layout,
      children: [
          {
              path: '',
              component: Presents,
              name: 'presents'
          },
          {
              path: 'form/:id?',
              component: PresentForm,
              props: true
          }
      ]
    },
    // {
    //     path:'/member',
    //     component: Layout,
    //     children: memberRouter
    // },
    // {
    //     path:'/products',
    //     component: Layout,
    //     children: productsRouter
    // },
    // {
    //     path: '/invest',
    //     component: Layout,
    //     children: investRouter
    // },
    // {
    //     path: '/payment',
    //     component: Layout,
    //     children: paymentRouter
    // },
    // {
    //     path: '/repayment',
    //     component: Layout,
    //     children: repaymentRouter
    // },
    // {
    //     path: '/loan',
    //     component: Layout,
    //     children: loanRouter
    // },
    // {
    //     path: '/settings',
    //     component: Layout,
    //     children: settingsRouter
    // },
    // {
    //     path: '/bulletin',
    //     component: Layout,
    //     children: bulletinRouter
    // },
    // {
    //     path: '/withholdingTax',
    //     component: Layout,
    //     children: withholdingTaxRouter
    // },
    {
        path: '/login',
        name: 'Login',
        component: Login
    }
]

const router = new VueRouter({
    scrollBehavior() {
        return { x:0, y: 0}
    },
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next)=> {
    if (getToken()) {
        next();
    } else if (to.path==='/login') {
        next();
    } else {
        // next('login');
        next();
    }
})

export default router
